export const NIGHTS = [
  { value: 0, text: '0 Nights' },
  {
    value: 1,
    text: '1 Night',
  },
  { value: 2, text: '2 Nights' },
  { value: 3, text: '3 Nights' },
  { value: 4, text: '4 Nights' },
  {
    value: 5,
    text: '5 Nights',
  },
  { value: 6, text: '6 Nights' },
  { value: 7, text: '7 Nights' },
  { value: 8, text: '8 Nights' },
  {
    value: 9,
    text: '9 Nights',
  },
  { value: 10, text: '10 Nights' },
  { value: 11, text: '11 Nights' },
  { value: 12, text: '12 Nights' },
  {
    value: 13,
    text: '13 Nights',
  },
  { value: 14, text: '14 Nights' },
];
